import Mutations from '../../odata/mutations';

export default { ...new Mutations('saltBin'), ...new Mutations('saltBins') };
